import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { featuredPeopleQueryKeys } from './query-keys';

export type TDeleteFeaturedPeopleParams = {
  id: string;
};

export function deleteFeaturedPeople({ id }: TDeleteFeaturedPeopleParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/peoples/${id}`);
}

type MutationFn = typeof deleteFeaturedPeople;

type UseDeleteFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteFeaturedPeople({ config }: UseDeleteFeaturedPeopleParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('La persona de interés no existe');
      }
      addErrorNotification('No se ha podido eliminar la persona de interés');
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: featuredPeopleQueryKeys.all });
      addSuccessNotification('La persona de interés se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteFeaturedPeople,
  });
}
